import React, { Fragment } from 'react';
import { currentBrand } from '../utils/brand';
import { getTranslation } from '../utils/translations';

const ErrorMessage = (props) => {
  const contactMessage = getTranslation('contactMessage', { brandEmail: currentBrand().emailRegistration });

  return (
    <Fragment>
      {props.error === true ? (
        <div className="alert alert-danger" role="alert">
          <p>{props.errorMessage}</p>
          <p>{contactMessage}</p>
        </div>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default ErrorMessage;
